module.exports = __webpack_public_path__ + "static/media/Arrow.3b8ad945.svg";